import { render, staticRenderFns } from "./CoursewareCompanionOverlay.vue?vue&type=template&id=574ee1fa&"
import script from "./CoursewareCompanionOverlay.vue?vue&type=script&lang=js&"
export * from "./CoursewareCompanionOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports